import { Injectable } from '@angular/core';
import Swal from 'sweetalert2/dist/sweetalert2.all.js';

@Injectable({
  providedIn: 'root'
})
export class SwalService {

  constructor() { }

  openErrorMessage(text) {
    Swal.fire({
      title: 'Lỗi',
      text,
      icon: 'error'
    });
  }

  openSuccessMessage(text) {
    return Swal.fire({
      title: 'Thành công',
      text,
      icon: 'success'
    });
  }

  openConfirmMessage(text, title) {
    return Swal.fire({
      title,
      text,
      icon: 'warning',
      confirmButtonText: 'OK',
      showCancelButton: true,
      cancelButtonText: 'Hủy'
    });
  }

}
